import { Link } from 'react-router-dom';
import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formError, setFormError] = useState('');

  const handleSubscribe = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    if (formData.get('website_alt')?.toString().trim()) {
      setSubscribed(true);
      setTimeout(() => setSubscribed(false), 3000);
      return;
    }

    setIsSubmitting(true);
    setFormError('');

    try {
      const response = await fetch('https://readdy.ai/api/form/d957hblcb7lqctnurovg', {
        method: 'POST',
        body: formData,
      });
      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      if (response.ok && parsed?.code === 'OK') {
        setSubscribed(true);
        form.reset();
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
        setFormError(serverMsg);
      }
    } catch {
      setFormError('Ошибка подключения. Попробуйте позже.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const columnLinks = [
    {
      title: 'Навигация',
      links: [
        { label: 'Главная', to: '/' },
        { label: 'Сравнение', to: '#compare' },
        { label: 'Категории', to: '#categories' },
        { label: 'FAQ', to: '#faq' },
      ],
    },
    {
      title: 'Статьи',
      links: [
        { label: 'Полное руководство', to: '/blog/yoybuy-spreadsheet-polnoe-rukovodstvo' },
        { label: 'Сравнение агентов', to: '#compare' },
        { label: 'Как это работает', to: '#how-it-works' },
      ],
    },
    {
      title: 'Платформа',
      links: [
        { label: 'yoybuy sheet', href: 'https://kaspreadsheet.com' },
        { label: 'buy it now', href: 'https://kaspreadsheet.com' },
        { label: 'Политика', href: '#' },
      ],
    },
    {
      title: 'Соцсети',
      links: [
        { label: 'Telegram', href: '#' },
        { label: 'VK', href: '#' },
        { label: 'Instagram', href: '#' },
      ],
    },
  ];

  return (
    <footer className="w-full bg-foreground-950 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20 mb-14">
          <div className="lg:w-1/3">
            <div className="flex items-center gap-1 mb-6">
              <span className="font-heading text-xl font-bold text-white">
                YOYBUY Spreadsheet
              </span>
              <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
            </div>

            <form
              id="newsletter-form"
              data-readdy-form
              onSubmit={handleSubscribe}
              className="flex flex-col gap-2 mb-6"
            >
              <input
                type="text"
                name="website_alt"
                className="hp-field"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
              />
              <div className="flex items-center gap-2">
                <input
                  type="email"
                  name="email"
                  placeholder="Ваш email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="flex-1 px-4 py-3 rounded-xl bg-white/10 border border-white/15 text-white text-sm placeholder:text-white/30 focus:outline-none focus:border-accent-500 transition-colors"
                  required
                />
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-11 h-11 rounded-xl bg-accent-500 text-foreground-950 flex items-center justify-center hover:bg-accent-400 transition-colors flex-shrink-0 cursor-pointer disabled:opacity-50"
                >
                  <i className="ri-mail-send-line text-lg"></i>
                </button>
              </div>
            </form>

            {subscribed && (
              <p className="text-accent-400 text-sm mb-4">Спасибо за подписку!</p>
            )}
            {formError && (
              <p className="text-red-400 text-sm mb-4">{formError}</p>
            )}

            <p className="font-heading text-2xl md:text-3xl text-white/80 leading-snug">
              Умный шопинг
              <br />
              из Китая без переплат
            </p>
          </div>

          <div className="lg:w-2/3 grid grid-cols-2 md:grid-cols-4 gap-8">
            {columnLinks.map((col) => (
              <div key={col.title}>
                <h4 className="text-white font-semibold text-sm mb-4 uppercase tracking-wider">
                  {col.title}
                </h4>
                <ul className="space-y-2.5">
                  {col.links.map((link) => (
                    <li key={link.label}>
                      {link.to ? (
                        link.to.startsWith('#') ? (
                          <a
                            href={link.to}
                            className="text-white/50 text-sm hover:text-white transition-colors whitespace-nowrap"
                          >
                            {link.label}
                          </a>
                        ) : (
                          <Link
                            to={link.to}
                            className="text-white/50 text-sm hover:text-white transition-colors whitespace-nowrap"
                          >
                            {link.label}
                          </Link>
                        )
                      ) : (
                        <a
                          href={link.href}
                          target="_blank"
                          rel="noopener nofollow"
                          className="text-white/50 text-sm hover:text-white transition-colors whitespace-nowrap"
                        >
                          {link.label}
                        </a>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/30 text-xs">
            &copy; 2026 YOYBUY Spreadsheet. yoybuy.link
          </p>
          <div className="flex items-center gap-3">
            {['ri-telegram-line', 'ri-vk-line', 'ri-instagram-line', 'ri-youtube-line'].map((icon) => (
              <a
                key={icon}
                href="#"
                className="w-9 h-9 rounded-lg border border-white/15 flex items-center justify-center text-white/40 hover:text-white hover:border-white/30 transition-all cursor-pointer"
              >
                <i className={`${icon} text-sm`}></i>
              </a>
            ))}
          </div>
          <a href="#" className="text-white/30 text-xs hover:text-white/50 transition-colors">
            Privacy Policy
          </a>
        </div>
      </div>
    </footer>
  );
}